module.exports = __webpack_public_path__ + "static/media/emergencySound2.ccdfc27d.mp3";